// AI Deep Analysis — uses the buyer's Groq API key (from Settings) for narrative.
// The PWA works fully without this; the key is optional.

import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiDeepAnalysis(
  contractText: string,
  onStream: (chunk: string) => void
): Promise<void> {
  const system = `You are a contract analyst specializing in freelance/service agreements. Identify all risky clauses. Explain in plain English. Suggest fair alternatives. Flag for attorney review when needed. Never give legal advice. Use Markdown.`;
  try {
    await streamGroq({
      messages: [
        { role: 'system', content: system },
        { role: 'user', content: `Contract text:\n\n${contractText}\n\nProvide comprehensive analysis.` },
      ],
      temperature: 0.3,
      onStream,
    });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) {
      onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ in the header to paste your free key from console.groq.com/keys. The core logic above works fully without it.');
      return;
    }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
